import React from 'react';
import ReactDOM from 'react-dom';
import loadTranslations from 'js/localeSetup';

import App from './app';

import './style.scss';

(async () => {
  const rootElement = document.getElementById('teamsport-index');
  await loadTranslations();

  if (rootElement) {
    ReactDOM.render(<App />, rootElement);
  }
})();
